import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "合同分类，某个类型", -1)

import { onMounted, ref } from 'vue';
import { GbDialog } from '@/components/GbDialog/Index';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const models = require.context('../../views', true, /\.vue$/);

onMounted(() => {
	// const testRoute = [{
	//     path: "/system_test",
	//     component: "GbLayout",
	//     redirect: "/system_test/user",
	//     meta: {
	//         title: "系统管理", icon: "system", hidden: false, roles: ["ADMIN"], keepAlive: true
	//     },
	//     children: [{
	//         path: "user",
	//         component: "systems/accounts/index",
	//         name: "User",
	//         meta: {
	//             title: "用户管理", icon: "user", hidden: false, roles: ["ADMIN"], keepAlive: true
	//         }
	//     }, {
	//         path: "role",
	//         component: "systems/role/index",
	//         name: "Role",
	//         meta: {
	//             title: "角色管理", icon: "role", hidden: false, roles: ["ADMIN"], keepAlive: true
	//         }
	//     }]
	// }]
	// const testMd = { ...testRoute }
	// const moduleKeys = models.keys().map((key: string) => {
	//     return  key.replace('./', '')
	// })
	// models.keys().forEach((key: any) => {
	// })
});

const cpData = [
	{ mianstay_name: 'A', is_enabled: 'Y', tips: '1213' },
	{ mianstay_name: 'B', is_enabled: 'Y', tips: 'abcd' },
	{ mianstay_name: 'C', is_enabled: 'Y', tips: '测试数据' },
];

const show = ref<boolean>(true);

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createBlock(_unref(GbDialog), {
    modelValue: show.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event))
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_el_table, {
        data: cpData,
        border: "",
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "mianstay_name",
            label: "主体名称",
            width: "240",
            "header-align": "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "部门审批(19001)",
            "header-align": "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "is_enabled",
                label: "必填",
                "header-align": "center"
              }),
              _createVNode(_component_el_table_column, {
                prop: "tips",
                label: "提示",
                "header-align": "center"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "使用人确认(19003)",
            "header-align": "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "is_enabled",
                label: "必填",
                "header-align": "center"
              }),
              _createVNode(_component_el_table_column, {
                prop: "tips",
                label: "提示",
                "header-align": "center"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "合同会签(19003\r\n            )",
            "header-align": "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "is_enabled",
                label: "必填",
                "header-align": "center"
              }),
              _createVNode(_component_el_table_column, {
                prop: "tips",
                label: "提示",
                "header-align": "center"
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})